var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ul",
        { staticClass: "record-list" },
        _vm._l(_vm.recordLists, function (item, index) {
          return _c("li", { key: index, staticClass: "item" }, [
            _c("div", { staticClass: "title-box" }, [
              _c("p", { staticClass: "date" }, [
                _c("i", { staticClass: "iconfont iconshijian00" }),
                _c("span", { staticClass: "span" }, [
                  _vm._v(_vm._s(item.created_at)),
                ]),
              ]),
              _c("p", { staticClass: "title" }, [
                _c("span", { staticClass: "span" }, [
                  _vm._v("[" + _vm._s(item.type_title) + "]"),
                ]),
                _c("span", { staticClass: "tit" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "progress-box" }, [
              _c("span", { staticClass: "primary" }, [
                _vm._v("已做：" + _vm._s(item.fulfil_number)),
              ]),
              _vm._v("/ "),
              _c("span", [_vm._v("总题：" + _vm._s(item.subject_total))]),
              _c(
                "span",
                {
                  staticClass: "primary",
                  staticStyle: { "margin-left": "20px" },
                },
                [_vm._v("得分：" + _vm._s(item.score))]
              ),
              _vm._v("/ "),
              _c("span", [_vm._v("总分：" + _vm._s(item.sum_score))]),
            ]),
            _c(
              "div",
              { staticClass: "link-box" },
              [
                item.doneNum == item.topicAllNum
                  ? _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.jumpAnalysis(item)
                          },
                        },
                      },
                      [_vm._v("查看解析")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    staticClass: "link-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.jump(item)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(item.is_submit === 2 ? "重新做题" : "继续做题")
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _vm.total > 0
        ? _c(
            "div",
            { staticStyle: { margin: "20px 0", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.pageInfo.page,
                  total: _vm.total,
                  "page-size": _vm.pageInfo.limit,
                  "page-sizes": [10, 20, 30, 50, 100],
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pageInfo, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pageInfo, "page", $event)
                  },
                  "current-change": _vm.currentChange,
                  "size-change": _vm.sizeChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.recordLists.length == 0
        ? _c("ComponentEmpty", { attrs: { title: "暂无做题记录", tips: "" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }